import { Component, Input } from '@angular/core';
import { GlucometerSupplies } from 'src/app/models/glucometer-supplies.model';

/**
 * Presentational component that shows the estimated glucometer strips/lancets remaining
 * (e.g. "25 / 100") plus an estimate disclaimer. When `supplies` is null it renders a
 * "not available" note. Stateless on purpose — the container owns the data fetch.
 */
@Component({
  selector: 'app-supply-estimate',
  templateUrl: './supply-estimate.component.html',
  styleUrls: ['./supply-estimate.component.scss'],
})
export class SupplyEstimateComponent {
  @Input() supplies: GlucometerSupplies | null = null;
}
